import React from 'react';
import { Label, } from 'components'
import { formatBookingStatus, } from 'helpers/helpers'
import PropTypes from 'prop-types'
import {
  colors,
} from '@material-ui/core'
import { BOOKED, WAIT_ACCEPT, CANCELED, REFUSED, HAS_CHECKOUT_NEEDS_RATING, HAS_CHECKOUT, } from 'constants/bookingStatus'

const BookingStatus = (props) => {
  const { status, } = props

  const statusColors = {
    [CANCELED]: colors.red[600],
    [REFUSED]: colors.red[600],
    [WAIT_ACCEPT]: colors.orange[600],
    [HAS_CHECKOUT_NEEDS_RATING]: colors.orange[600],
    [HAS_CHECKOUT]: colors.green[600],
    [BOOKED]: colors.green[600],
  }

  return status !== null ? (
    <Label
      color={statusColors[status]}
      variant="outlined"
    >
      {formatBookingStatus(status)}
    </Label>
  ) : null
}

BookingStatus.propTypes = {
  status: PropTypes.number,
};

export default BookingStatus
